import {Component, OnDestroy, OnInit} from '@angular/core';
import { NavigatorService }  from '../../services/navigator.service';
import { AppStatusService }  from '../../services/app-status.service';
import { StatusListener }     from '../../status-listener';
import {CartApi}             from '../../services/api/cart-api.service';
import { ApiService }        from "../../services/api.service";
import {AppService} from '../../services/app.service';
import {AppStatus} from '../../@models/app-status';

@Component({
	selector: 'terminal',
	templateUrl: './terminal.component.html',
	styleUrls: ['./terminal.component.scss', "../tur/tur.components.scss"]
})
export class TerminalComponent extends StatusListener implements OnInit, OnDestroy {

	itemsInCart: boolean = false;
	cartItemsLen = 0;
	cartMaximum = 0;

	constructor(app: AppService) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);
		this.cartMaximum = status.deviceStatus.UIConfig.CartItemsCount;
		this.cartItemsLen = status.deviceStatus.VendingStatus.Cart.Items.length;
		this.itemsInCart = this.cartItemsLen > 0;
	}

	async cancel() {
		await this.app.api.cartApi.clear();
		await this.app.nav.cancelOrder(true);
	}
}
